import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

const BehaviorFiltersIcon = (props: any) => {
  const theme = useContext(ThemeContext);
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4.11401 4.97266C3.22901 5.88099 2.58651 7.02266 2.27734 8.29599"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.74219 17.0332C8.23469 17.1398 8.74552 17.199 9.27052 17.199C10.0139 17.199 10.7314 17.0857 11.4064 16.8765"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.27734 11.6991C2.58651 12.9724 3.22901 14.1141 4.11401 15.0224"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.1715 12.0508C15.8223 13.2274 15.1773 14.2749 14.3281 15.1158"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.3281 4.87891C15.1773 5.71974 15.8215 6.76724 16.1715 7.94391"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.74219 2.96422C8.23469 2.85755 8.74552 2.79839 9.27052 2.79839C10.0139 2.79839 10.7314 2.91172 11.4064 3.12089"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9451 8.52426C18.7587 9.33785 18.7587 10.6569 17.9451 11.4705C17.1315 12.2841 15.8125 12.2841 14.9989 11.4705C14.1853 10.6569 14.1853 9.33785 14.9989 8.52426C15.8125 7.71066 17.1316 7.71066 17.9451 8.52426"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.3553 14.6375C8.16889 15.4511 8.16889 16.7702 7.3553 17.5838C6.54171 18.3974 5.22261 18.3974 4.40902 17.5838C3.59543 16.7702 3.59543 15.4511 4.40902 14.6375C5.22262 13.8239 6.54171 13.8239 7.3553 14.6375"
        stroke={theme.colors.neutrals.c400}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.3553 2.41098C8.16889 3.22457 8.16889 4.54366 7.3553 5.35725C6.54171 6.17084 5.22261 6.17084 4.40902 5.35725C3.59543 4.54366 3.59543 3.22457 4.40902 2.41098C5.22262 1.59738 6.54171 1.59738 7.3553 2.41098"
        stroke={theme.colors.neutrals.c400}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BehaviorFiltersIcon;
